import { FC, ReactNode } from 'react'

import { styled } from 'styled-components'

import { fontSizePageTitle, fontWeightSemibold } from 'core/styles'

type PageHeaderProps = {
  title: string
  /** Rendered opposite the title, e.g. a Create call to action. */
  action?: ReactNode
  /** Rendered before the title, e.g. a Back control on a nested page. */
  back?: ReactNode
}

const PageHeader: FC<PageHeaderProps> = ({ title, action, back }) => (
  <Header>
    <TitleRow>
      {back}
      <Title>{title}</Title>
    </TitleRow>
    {action}
  </Header>
)

export default PageHeader

const Header = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`

const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: start;
  min-width: 0;
`

const Title = styled.h2`
  margin: 0;
  color: ${(p) => p.theme.text};
  font-size: ${fontSizePageTitle};
  font-weight: ${fontWeightSemibold};
`
